import React from 'react';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';
import persianJs from 'persianjs'

import services from 'core/services';
import { PureComponent, Form, GroupBox } from 'core/components';
import { withLocale } from 'core/decorators';
import { Icon, List, ListInput, Button, CardContent } from 'core/components/Framework7';
import { Login } from 'core/module/operations';

import classes from './styles.module.css';

const NumericInput = Form.NumericInput;

class ForgetPassword extends PureComponent {
  constructor(props) {
    super(props)

    this.router = this.$f7.views.current && this.$f7.views.current.router

    this.state = {
      step: 1,
      phone: '',
      code: '',
      newPassword: '',
      newPasswordAgain: '',
    }
  }

  sendCode() {
    const { phone } = this.state;

    this.$f7.dialog.preloader('در حال ارسال اطلاعات');

    const model = {
      mobile: phone
    }

    const params = {
      errorHandler: true
    }

    services.ecommerce.User.forgetPassword(model, params)
      .then(r => {
        this.setState({ step: 2 })
      })
      .catch(e => {
        this.$f7.dialog.alert('این شماره در سیستم موجود نیست', 'خطا');
      })
      .finally(r => {
        this.$f7.dialog.close()
      })
  }

  verifyCode() {
    const { phone, code } = this.state;

    this.$f7.dialog.preloader('در حال ارسال اطلاعات');

    const model = {
      code,
      mobile: phone
    }

    const params = {
      errorHandler: true
    }

    services.ecommerce.User.ForgetPasswordCode(model, params)
      .then(r => {
        this.setState({ step: 3 })
      })
      .catch(e => {
        this.$f7.dialog.alert('کد وارد شده صحیح نمی باشد', 'خطا');
      })
      .finally(r => {
        this.$f7.dialog.close()
      })
  }

  sendNewPassword() {
    const { phone, code, newPassword } = this.state;

    this.$f7.dialog.preloader('در حال ارسال اطلاعات');

    const model = {
      username: phone,
      code,
      password: newPassword,
    }

    const params = {
      forgot: true,
      errorHandler: true
    }

    services.ecommerce.User.forgetPasswordFinalize(model, params)
      .then(r => {
        this.props.Login(phone, newPassword)
          .then(r => {
            this.$f7.dialog.alert('رمز عبور با موفقیت تغییر کرد.', 'تغییر رمز عبور');
            // this.props.navigate.navigate('/profile')
            this.router && this.router.back('/profile#/', { force: true })
          })
      })
      .catch(e => {
        this.$f7.dialog.alert('خطایی رخ داده، لطفا دوباره تلاش کنید', 'خطا');
      })
      .finally(r => {
        this.$f7.dialog.close()
      })
  }

  handlePhone(e) {
    if (!e.target.value || e.target.value == "") {
      this.setState({
        phone: ''
      })

      return
    }
    
    this.setState({
      phone: persianJs(e.target.value).toEnglishNumber().toString()
    })
  }

  handleCode(e) {
    if (!e.target.value || e.target.value == "") {
      this.setState({
        code: ''
      })

      return
    }

    this.setState({
      code: persianJs(e.target.value).toEnglishNumber().toString()
    })
  }

  handleNewPassword(e) {
    this.setState({
      newPassword: e.target.value
    })
  }

  handleNewPasswordAgain(e) {
    this.setState({
      newPasswordAgain: e.target.value
    })
  }

  handleSubmit() {
    const { step } = this.state;

    switch (step) {
      case 1:
        return this.sendCode();
      case 2:
        return this.verifyCode();
      case 3:
        return this.sendNewPassword()
    }
  }

  hasError() {
    const { step, phone, code, newPassword, newPasswordAgain } = this.state;

    let valid = false

    switch (step) {
      case 1:
        valid = (phone.length == 11 || phone.length == 10)
        break
      case 2:
        valid = (code.length >= 4)
        break
      case 3:
        valid = (newPassword.length >= 4) && (newPasswordAgain == newPassword)
        break
    }

    return !valid
  }

  onSubmit(e) {
    e.preventDefault();
  }

  render() {
    const { step, phone, code, newPassword, newPasswordAgain } = this.state;

    return (
      <form action="" onSubmit={this.onSubmit} className={classes.container}>
        <div className={`${classes.pagePadding}`}>
          <GroupBox outline title='فراموشی رمز عبور'>
            <CardContent>
              <div className={classes.fullName}>
                {/* {`${user.firstName} ${user.lastName}`} */}
              </div>
              <List noHairlinesMd>
                <ListInput
                  type="tel"
                  clearButton={step == 1}
                  required
                  validate
                  value={phone}
                  placeholder="شماره تلفن همراه خود را وارد کنید"
                  info={'مانند ۰۹۱۲۳۴۵۶۷۸۹'}
                  errorMessage={'لطفا شماره تلفن همراه خود را وارد کنید'}
                  disabled={step > 1}
                  onInputClear={() => this.setState({ phone: '' })}
                  onChange={this.handlePhone}
                >
                  <Icon icon="mdi-phone" slot="media" />
                </ListInput>

                {step == 2 &&
                  <ListInput
                    type="number"
                    pattern="\d*"
                    clearButton
                    required
                    validate
                    value={code}
                    placeholder="کد تأیید"
                    info={'کد تأیید ارسال شده به شماره تلفن همراه'}
                    errorMessage={'لطفا کد تأیید ارسال شده به شماره تلفن همراه خود را وارد کنید'}
                    onInputClear={() => this.setState({ code: '' })}
                    onChange={this.handleCode}
                  >
                    <Icon icon="mdi-lock-open" slot="media" />
                  </ListInput>
                }

                {step == 3 &&
                  <ListInput
                    type="password"
                    // label={'رمز عبور'}
                    clearButton
                    required
                    validate
                    value={newPassword}
                    placeholder="رمز عبور جدید را وارد کنید"
                    info={'اجباری، حداقل ۴ حرف'}
                    errorMessage={'لطفا رمز عبور جدید خود را وارد کنید'}
                    onInputClear={() => this.setState({ newPassword: '' })}
                    onChange={this.handleNewPassword}
                  >
                    <Icon icon="mdi-account-key" slot="media" />
                  </ListInput>
                }
                {step == 3 &&
                  <ListInput
                    type="password"
                    // label={'تکرار رمز عبور'}
                    clearButton
                    required
                    validate
                    value={newPasswordAgain}
                    placeholder="رمز عبور جدید را مجدد وارد کنید"
                    info={'اجباری'}
                    errorMessage={'لطفا رمز عبور جدید را مجدد وارد کنید'}
                    onInputClear={() => this.setState({ newPasswordAgain: '' })}
                    onChange={this.handleNewPasswordAgain}
                  >
                    <Icon icon="mdi-account-key" slot="media" />
                  </ListInput>
                }
              </List>
            </CardContent>
          </GroupBox>
        </div>

        <Button large fill
          type='submit'
          icon={step == 1 ? 'mdi-cellphone-message' : step == 2 ? 'mdi-phone-check' : step == 3 ? 'mdi-account-check' : false}
          text={step == 1 ? "ارسال کد تأیید" : step == 2 ? "تأیید کد" : step == 3 ? "ثبت اطلاعات" : ''}
          className={classes.fullWidthButton}
          disabled={this.hasError()}
          onClick={this.handleSubmit}
        />
      </form>
    )
  }
}

export default connect(
  state => ({

  }),
  {
    Login
  }
)(withLocale('forget_password')(autobind(ForgetPassword)))